// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"41d8af0b","787":"00933c7b"}[chunkId] + ".chunk.js";
};